import React from 'react';
import { FileText } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import SEOHead, { ADVISOR_NAME, ADVISOR_PHONE_DISPLAY, ADVISOR_EMAIL } from '../components/SEOHead';

const TermsOfService = () => {
  const { i18n } = useTranslation();
  const isTe = i18n.language === 'te';

  return (
    <div className="min-h-screen pt-24 pb-20 bg-slate-50 dark:bg-slate-950">
      <SEOHead
        title={isTe ? 'సేవా నిబంధనలు | VSR Insurance Plus' : 'Terms of Service | VSR Insurance Plus'}
        description={isTe ? 'లైసెన్స్ పొందిన బీమా సలహాదారు వి. ఎస్. రెడ్డి నేతృత్వంలోని VSR Insurance Plus సేవా నిబంధనలు మరియు సలహా పరిధి.' : 'Terms of service and advisory scope for VSR Insurance Plus, led by licensed insurance advisor V. S. Reddy.'}
        canonicalPath="/terms"
        breadcrumbs={[{ name: isTe ? 'సేవా నిబంధనలు' : 'Terms of Service', path: '/terms' }]}
      />

      <div className="container mx-auto px-6 max-w-4xl">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 p-2 px-4 bg-blue-100 dark:bg-blue-900/30 text-primary rounded-full text-xs font-bold uppercase tracking-wider mb-4">
            <FileText className="w-3.5 h-3.5" /> {isTe ? 'సలహా పరిధి & వినియోగదారు ఒప్పందం' : 'Advisory Scope & User Agreement'}
          </div>
          <h1 className="text-3xl md:text-5xl font-extrabold text-slate-900 dark:text-white mb-4 tracking-tight">
            {isTe ? 'సేవా నిబంధనలు' : 'Terms of Service'}
          </h1>
          <p className="text-sm text-slate-500">
            {isTe ? 'చివరిగా నవీకరించబడింది: అక్టోబర్ 2026' : 'Last Updated: October 2026'}
          </p>
        </div>

        <div className="bg-white dark:bg-slate-900 p-8 md:p-12 rounded-3xl border border-slate-200 dark:border-slate-800 shadow-sm space-y-8 text-sm text-slate-600 dark:text-slate-400 leading-relaxed">
          <section>
            <h2 className="text-xl font-bold text-slate-900 dark:text-white mb-3">
              {isTe ? '1. సలహా సేవల స్వభావం' : '1. Nature of Advisory Service'}
            </h2>
            <p>
              {isTe
                ? 'విఎస్ఆర్ ఇన్సూరెన్స్ ప్లస్ అనేది ఎస్వీఆర్ ఎల్ఐసి సర్వీసెస్ ఆధ్వర్యంలో పనిచేసే స్వతంత్ర బీమా కన్సల్టెన్సీ. ఈ వెబ్‌సైట్‌లోని సమాచారం, కాలిక్యులేటర్లు మరియు కొటేషన్లు కేవలం విద్యాపరమైన మరియు సలహా సహాయం కోసం మాత్రమే ఉద్దేశించబడ్డాయి.'
                : 'VSR Insurance Plus is an independent insurance advisory platform operated by SVR LIC Services under the licensed leadership of Senior Insurance Advisor V. S. Reddy. The content, calculation estimators, and illustrations provided on this website are designed for educational, informational, and advisory assistance.'}
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 dark:text-white mb-3">
              {isTe ? '2. అండర్‌రైటింగ్ మరియు పాలసీ జారీ' : '2. Insurer Underwriting & Policy Issuance'}
            </h2>
            <p>
              {isTe
                ? 'ఏదైనా బీమా పాలసీని ఆమోదించడం, ప్రీమియం నిర్ణయించడం మరియు క్లెయిమ్‌లను పరిష్కరించడం అనేది సంబంధిత బీమా సంస్థల (ఎల్ఐసి లేదా హెచ్‌డిఎఫ్‌సి ఎర్గో) అండర్‌రైటింగ్ నిబంధనల ప్రకారం జరుగుతుంది.'
                : 'All insurance proposals are subject to underwriting acceptance, medical evaluation, and final issuance by the respective insurance provider: Life Insurance Corporation of India (LIC) for life/pension products, or HDFC ERGO General Insurance Company Ltd for health insurance products.'}
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 dark:text-white mb-3">
              {isTe ? '3. సంప్రదింపు వివరాలు' : '3. Advisory Queries'}
            </h2>
            <div className="p-4 bg-slate-50 dark:bg-slate-950 rounded-xl space-y-1 text-xs mt-2">
              <p><strong>{isTe ? 'సలహాదారు:' : 'Advisor:'}</strong> {ADVISOR_NAME}</p>
              <p><strong>{isTe ? 'ఏజెన్సీ:' : 'Agency:'}</strong> VSR Insurance Plus (SVR LIC Services)</p>
              <p><strong>{isTe ? 'ఫోన్:' : 'Phone:'}</strong> {ADVISOR_PHONE_DISPLAY}</p>
              <p><strong>{isTe ? 'ఇమెయిల్:' : 'Email:'}</strong> {ADVISOR_EMAIL}</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
